import { ReviewSourceType } from "../types"

type ReviewWithSource = {
  source?: {
    type: ReviewSourceType | null
    url?: string | null
  } | null
}

/**
 * Return true if the review is from an external source (not from the app)
 */
export const isExternalReview = ({ source }: ReviewWithSource) => source?.type !== ReviewSourceType.InApp
